import React from 'react';
import Kiosk from './Kiosk';
import { STEPS } from 'utils/kiosk';

/**
 * @param {Object} props - see propTypes
 * @returns {Object} A kiosk that allows students to check-in virtually via authentication or as a prospective student
 * (if enabled).
 */
function AuthenticatedCheckInContainer(props) {
    return <Kiosk {...props} initialStep={STEPS.AUTHENTICATED_SIGN_IN} />
}

export default AuthenticatedCheckInContainer;
